import { Fragment } from "react"

import { Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { LabelTag } from "@/molecules/LabelTag"
import { useIssue } from "@/organisms/Drawers/applications/triage/useTriage"
import { TAB_NAMES } from "@/organisms/Drawers/const"
import { changeTab } from "../../changeTab"
import {
  ACTION_ICON,
  ACTION_TYPE_ORDER,
  countActionsByType
} from "../takenActions.selector"
import { useTakenActions } from "../useTakenActions"
import { ActionIndicator } from "./ActionIndicator"

import styles from "../TakenActions.module.scss"

export const ActionsMetaBar = ({
  issueId,
  drawerId
}: {
  issueId?: string
  drawerId?: string
}) => {
  const { t } = useTranslation()
  const { response } = useIssue(issueId)
  const record = response?.data?.[0]
  const { actions } = useTakenActions(issueId)

  const counts = countActionsByType(actions)
  const activeTypes = ACTION_TYPE_ORDER.filter((type) => counts[type] > 0)
  const hasLabels = !!record?.labels?.length

  if (!activeTypes.length && !hasLabels) return null

  return (
    <div className={styles.bar}>
      {!!activeTypes.length && (
        <>
          <Text className={styles.barLabel}>{`${t(
            "triage.remediation.actions.title"
          )}:`}</Text>
          <div className={styles.indicators}>
            {activeTypes.map((type, index) => (
              <Fragment key={type}>
                {index > 0 && <span className={styles.barDivider} />}
                <ActionIndicator
                  Icon={ACTION_ICON[type]}
                  count={counts[type]}
                  onClick={() => changeTab(drawerId, TAB_NAMES.remediation)}
                />
              </Fragment>
            ))}
          </div>
        </>
      )}
      {hasLabels && record && (
        <div className={styles.labelsGroup}>
          <Text className={styles.barLabel}>{`${t(
            "settings.labels.title"
          )}:`}</Text>
          <div className={styles.labels}>
            <LabelTag labels={record.labels} type="line" issueId={record.id} />
          </div>
        </div>
      )}
    </div>
  )
}
